export function StatusBadge({ status, className = '' }) {
  const statusConfig = {
    new: { label: 'New', className: 'new' },
    contacted: { label: 'Contacted', className: 'contacted' },
    pending: { label: 'Pending', className: 'pending' },
    active: { label: 'Active', className: 'active' },
    inactive: { label: 'Inactive', className: 'inactive' },
  };

  const config = statusConfig[status?.toLowerCase()] || statusConfig.pending;

  return (
    <span className={`status-badge ${config.className} ${className}`}>
      {config.label}
    </span>
  );
}
